"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Layout_1 = __importDefault(require("@comp/Layout"));
const utterances_1 = __importDefault(require("@comp/utterances"));
async function GuestBook() {
    document.title = `영범 블로그 | Guestbook`;
    const content = `
    <section>
      <div class="flex justify-center py-24">
        <div class="text-subTitle md:text-title">자유롭게 방명록을 작성해주세요 🤗</div>
      </div>
      <div id="utterances-container"></div>
    </section>
  `;
    const layoutContent = await (0, Layout_1.default)(content);
    const appDiv = document.getElementById("app");
    if (appDiv) {
        appDiv.innerHTML = "";
        appDiv.appendChild(layoutContent);
        // layoutContent가 DOM에 추가된 후에 utterances를 로드합니다.
        (0, utterances_1.default)("y-baaam/VanillaJS-Blog-Project");
    }
    return layoutContent;
}
exports.default = GuestBook;
